module.exports = __webpack_public_path__ + "media/src/images/course_default-40bf34754a1b16d637c4bee1bd132bf7.png";